import { useField } from "formik";
import { IconFileBroken } from "@tabler/icons-react";
// @ts-expect-error pure js
import FormUpload from "../File/FormUpload";
import DocumentDownloadLink from "../UI/DocumentDownloadLink";
// @ts-expect-error pure js
import DocumentThumbnail from "../UI/DocumentThumbnail";
import Status from "../UI/Status";
import SortablePhotoGrid from "../UI/SortablePhotoGrid";
import styles from "./EdlPhotoField.module.css";

export type PhotoFile = {
  id?: number;
  src: string;
  thumbnail?: string;
  filename?: string;
  mimetype?: string;
  localFile?: Blob;
};

function EdlPhotoTile({
  file,
  isCover,
  onDelete,
}: {
  file: PhotoFile;
  isCover: boolean;
  onDelete: () => void;
}) {
  // Les photos d'EDL sont servies depuis le store "files" (et non "documents"),
  // d'où le downloadUrl explicite plutôt qu'un documentId.
  const downloadUrl = file.id ? `edl/photos/${file.id}/download` : undefined;

  return (
    <div className={styles.tile}>
      <DocumentDownloadLink
        downloadUrl={downloadUrl}
        file={file}
        mimetype={file.mimetype}
      >
        <DocumentThumbnail
          downloadUrl={downloadUrl}
          file={file}
          mimetype={file.mimetype}
          onDelete={onDelete}
          fallback={<IconFileBroken />}
        />
      </DocumentDownloadLink>
      {isCover && (
        <Status color="info" className={styles.cover} text="Couverture" />
      )}
    </div>
  );
}

export default function EdlPhotoField({
  path,
  text = "Ajouter des photos",
  showCover = true,
}: {
  path: string;
  text?: string;
  showCover?: boolean;
}) {
  const [{ value }, , { setValue }] = useField<PhotoFile[]>(path);
  const photos = value || [];

  return (
    <div className={styles.container}>
      <FormUpload
        tag="edl_photo"
        path={path}
        text={text}
        fileType="edl"
        hideList
      />
      {photos.length > 0 && (
        <SortablePhotoGrid
          items={photos}
          getId={(file) => file.src}
          onReorder={setValue}
        >
          {(file, index) => (
            <EdlPhotoTile
              file={file}
              isCover={showCover && index === 0}
              onDelete={() =>
                setValue(photos.filter((p) => p.src !== file.src))
              }
            />
          )}
        </SortablePhotoGrid>
      )}
    </div>
  );
}
